import styled, { css } from 'styled-components';
import theme from './theme';

const Root = styled.div.attrs(() => ({ className: 'data-grid' }))`
  ${theme};
  --selection-color: ${({ theme: t }) => t.colors.blueLight};
  --font-size: 13px;
  contain: strict;
  contain: size layout style paint;
  content-visibility: auto;
  height: 350px;
  border: 1px solid ${({ theme: t }) => t.colors.grey2};
  box-sizing: border-box;
  overflow: auto;
  overflow: overlay;
  background-color: var(--background-color);
  color: var(--color);
  font-size: var(--font-size);
  flex: 1;
  position: relative;

  z-index: 0;

  ${({ $isLoading }) => $isLoading && 'opacity: 0.4'};

  ${({ $scrolledLeft }) =>
    $scrolledLeft &&
    css`
      .cell.last-frozen {
        box-shadow: 2px 0 5px -2px rgba(136, 136, 136, 0.3);
        border-right: 1px solid var(--border-color) !important;
      }
    `}

  ${({ $isGroupedData }) =>
    $isGroupedData &&
    css`
      .row.group {
        background-color: ${({ theme: t }) => t.colors.white};
      }
    `}


  .row.summarized {
    cursor: default;
    background: ${({ theme: t }) => t.colors.grey1}!important;
    position: sticky;
  }
`;

export default Root;
